import { z } from 'zod'
import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { PlayerImageSchema } from '../players/api'
import { TeamLogoSchema } from '../assets/api'

const getProgress = async ({ competition_id }: { competition_id: number }) => {
  const response = await axios.get(
    `/api/competitions/${competition_id}/progress`
  )
  return ProgressSchema.parse(response.data)
}

export const useProgress = ({
  competition_id,
  player_id,
}: {
  competition_id: number
  player_id: number | null
}) => {
  return useQuery({
    queryKey: ['progress', { competition_id, player_id }],
    queryFn: ({ queryKey }) => {
      const [, { competition_id }] = queryKey as [
        string,
        { competition_id: number; player_id: number | null },
      ]
      return getProgress({ competition_id })
    },
    enabled: player_id !== null,
  })
}

export const ProgressSchema = z.object({
  user_id: z.number(),
  user_name: z.string(),
  user_photo: PlayerImageSchema,
  player_id: z.number(),
  current_round_rank: z.number(),
  rank_change: z.number(),
  current_round_rating: z.number(),
  team_id: z.number().nullable(),
  team_name: z.string().nullable(),
  team_logo: TeamLogoSchema,
  team_current_rank: z.number().nullable(),
  team_rank_change: z.number().nullable(),
  team_current_rating: z.number().nullable(),
})

export type Progress = z.infer<typeof ProgressSchema>
